import { render, staticRenderFns } from "./AbonementSections.vue?vue&type=template&id=c623b9d2&scoped=true&lang=pug&"
import script from "./AbonementSections.vue?vue&type=script&lang=js&"
export * from "./AbonementSections.vue?vue&type=script&lang=js&"
import style0 from "./AbonementSections.vue?vue&type=style&index=0&id=c623b9d2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c623b9d2",
  null
  
)

export default component.exports